import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useEntities } from "@hooks/useEntities";
import { useActiveWorkspaceRole } from "@hooks/permissions/useActiveWorkspaceRole";
import { MemberManagementOverlayEntity } from "./memberManagement.types";

interface MemberManagementOverlayData {
    workspaceId?: string;
    actingUserRole?: UserWorkspaceRole;
    entities?: MemberManagementOverlayEntity[];
}

export function useMemberManagementDefaults(
    overlayData: MemberManagementOverlayData,
) {
    const activeWorkspace = useActiveWorkspace();
    const actingUserRoleInActiveWorkspace = useActiveWorkspaceRole();
    const entitiesUserCanAdminister = useEntities({
        requireAdminAccess: true,
        excludeMockEntities: true,
    });

    const workspaceId = overlayData.workspaceId ?? activeWorkspace?.id;
    const actingUserRole =
        overlayData.actingUserRole ?? actingUserRoleInActiveWorkspace;
    const entities = overlayData.entities ?? entitiesUserCanAdminister;

    return { workspaceId, actingUserRole, entities };
}
